import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/settings')({
  beforeLoad: ({ location }) => {
    if (location.pathname === '/settings' || location.pathname === '/settings/') {
      // eslint-disable-next-line @typescript-eslint/only-throw-error
      throw redirect({ to: '/settings/services' });
    }
  },
  component: Outlet,
});
